const scorecard = [
  { value: "40", label: "SDRs led at peak", source: "Paystand" },
  { value: "4", label: "frontline leaders managed", source: "Paystand" },
  { value: "300%+", label: "YoY meeting growth", source: "Paystand" },
  { value: "79%", label: "of company pipeline sourced by Sales Development", source: "Paystand" },
  { value: "$25M+", label: "opportunity pipeline", source: "Ushur" },
  { value: "$5.4M", label: "closed-won ARR", source: "Ushur" }
];

// Executive Scorecard
export const MetricsBar = () => (
  <section id="track-record" className="relative py-12 sm:py-16 lg:py-20 bg-[#1C1C1C] border-y border-white/5 overflow-hidden" data-testid="scorecard-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="text-center mb-10">
        <div className="text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-3">Executive Scorecard</div>
        <p className="text-zinc-300">Selected results from Sales Development organizations I've led.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
        {scorecard.map((m, i) => (
          <div key={m.label} className="text-center p-4 sm:p-6 lg:p-7 bg-[#0A0A0A]/50 rounded-xl border border-white/5" data-testid={`scorecard-item-${i}`}>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#D4AF37] mb-1 sm:mb-2">{m.value}</div>
            <div className="text-xs sm:text-sm text-zinc-200 mb-2">{m.label}</div>
            <div className="text-[10px] sm:text-xs font-mono uppercase tracking-widest text-zinc-500">{m.source}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Problem Statement Section
export const ProblemSection = () => (
  <section className="py-20 lg:py-24 bg-[#0A0A0A]">
    <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
      <div className="text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-6">The Real Issue</div>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight leading-tight mb-6">
        Most pipeline problems are <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#E8C547]">execution problems.</span>
      </h2>
      <p className="text-lg text-zinc-300 max-w-2xl mx-auto mb-8">
        Not activity. Not effort. <span className="text-white font-medium">Systems.</span>
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {["Weak outbound discipline", "Underdeveloped talent", "Disconnected GTM", "Over-reliance on inbound"].map((item) => (
          <span key={item} className="px-4 py-2 bg-[#1C1C1C] border border-white/5 rounded-full text-sm text-zinc-300">
            {item}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default MetricsBar;
